import { render, staticRenderFns } from "./CustomFormsList.vue?vue&type=template&id=684a85df&scoped=true&"
import script from "./CustomFormsList.vue?vue&type=script&lang=js&"
export * from "./CustomFormsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormsList.vue?vue&type=style&index=0&id=684a85df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a85df",
  null
  
)

export default component.exports